import { render, staticRenderFns } from "./wordBook.vue?vue&type=template&id=11ffd252&scoped=true"
import script from "./wordBook.vue?vue&type=script&lang=js"
export * from "./wordBook.vue?vue&type=script&lang=js"
import style0 from "./wordBook.vue?vue&type=style&index=0&id=11ffd252&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ffd252",
  null
  
)

export default component.exports